import classNames from "classnames";

import { Header } from "../../components/header/header";
import { PageSupport } from "../../components/utilities/page-support";
import "../../styles/development.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import { committees } from "../../_helpers/development";
import { useState } from "react";
import { FlipAnim, Stretch } from "../../components/cards/anims";

export const Development = () => {

    const [viewed, setViewed] = useState(0);

    const toggleView = (k) => {
        viewed === k ? setViewed() : setViewed(k);
    }

    return (
        <div className="f-pg">
            <PageSupport />
            <Header pageTitle={"Development"} />
            <div className="dev-container">
                <Stretch>
                    <div className={classNames('pg-cap', 'cap-unit')}>SPECIALIZED COMMITTEES</div>
                </Stretch>
                <FlipAnim>
                    <div className="sub-cap">Membership</div>
                    <p className="dev-details">
                        Members of the Specialized Committees shall be proposed by the President General and approved by the ELT. Committee heads or coordinators, shall in consultations with the initial proposed members coopt new members into the committee on an ad-hoc (short-term) or permanent basis, as the case may be
                    </p>
                </FlipAnim>
                <FlipAnim>
                    <div className="sub-cap">Scope of Work</div>
                    <div className="dev-details">
                        The overall idea here is to tackle the development of the village from a holistic or integral approach.Holistic or integral development requires expertise in multidisciplinary domains that members of the executive may not have. It is therefore of import here to solicit additional hands from Mbei sons and daughters across the world who have the requires competencies, talents and expertise needed. With this in mind, below is a cliché of the scope of work we assigned to the aforementioned specialized committees.
                    </div>
                </FlipAnim>
                <FlipAnim>
                    <div className="sub-cap">Proposed committees</div>
                    <p className="dev-details">
                        MBECUDA comprises some specialised committees which have been proposed from the start, but can be modified if need arises. These commitees include:
                    </p>
                </FlipAnim>
                {committees.map((comm, k) => (
                    <div key={k}>
                        <div className={classNames("dev-unit", 'unit-lbl')} onClick={() => toggleView(k)}>
                            <div className="dev-unit-text" >{comm.caption}</div>
                            <FontAwesomeIcon
                                icon={faChevronCircleDown}
                                className={classNames("dev-unit-text", { 'fold-chev': viewed === k }, 'norm-chev')}
                            />
                        </div>
                        <div
                            className={classNames('comm-det', { 'view': viewed === k })}
                            dangerouslySetInnerHTML={{ __html: comm.info }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}